<template>
    <div>
        <div class="header">
            <a href="/">
                <img src="../../images/header-logo.png" alt="Logo" class="logo">
            </a>
        </div>
        <div class="modelings container py-5">
            <div class="table-responsive" >
                <div v-bind:class="['alert alert-info', hidden]" role="alert">
                    Please enter your credentials <RouterLink to="/"><b>here</b></RouterLink>.
                </div>
                <table class="table table-bordered table-responsive-md">
                    <thead>
                        <tr>
                            <th class="text-center">{{ $t('dataSpaces') }}</th>
                        </tr>
                        <tr>
                            <td style="padding:0" >
                                <input class="form-control" style="border:none" :placeholder="$t('filterByName')" v-model="filterInput" type="search">
                            </td>
                        </tr>
                    </thead>
                    <tbody v-if="listOfDataSpaces.length > 0">
                        <tr v-for="(item, i) in listOfDataSpaces" :key="i">
                            <td>
                                <RouterLink :to="{ name: 'dataspace', params: { id: item.id } }">
                                    {{ item.name }} 
                                </RouterLink>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            {{ $t('noAssignedDataSpace') }}
                        </tr>
                    </tbody>
                    
                </table>
            </div>
            <div class="under-buttons">
                <div v-if="loginInfo.userrole == 'Admin' && loginInfo.isAuthenticated" style="float:left">
                    <RouterLink to="settings/dataspaces" class="btn btn-secondary"> 
                        {{ $t('settings') }}
                    </RouterLink>
                </div>
                <div class="logout">
                    <button type="button" class="btn btn-secondary" @click="changeUser()" style="float:right; margin-right:20px">
                        {{ $t('logout') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import DataSpaceApi from "../../api/server/dataspace";
import authApi from "../../api/server/authorization"

export default {
    name: "DataSpaceList",
    mounted() {
        this.requestData();
    },
    computed: { 
        listOfDataSpaces() {
            var dataSpaceList = this.dataSpaceList;

            if (this.filterInput) {
                const lowerCaseFilter = this.filterInput.toLowerCase()
                dataSpaceList = dataSpaceList.filter((viz) => { 
                    if(viz.name.toLowerCase().includes(lowerCaseFilter))

                    return viz;
                });
            }

            return dataSpaceList.sort((a, b) => a.name.localeCompare(b.name));
        }
    },
    methods: {
        async requestData() {
            this.loginInfo = await authApi.auth();
            var groupId = this.loginInfo.usergroup;
            var allDataSpaces = await DataSpaceApi.dataSpaceList();
            if(this.loginInfo.userrole == "Admin") {
                this.dataSpaceList = allDataSpaces;
            } else {
                for (var i in allDataSpaces) {
                    var dataSpace = allDataSpaces[i];
                    var parsedContent = JSON.parse(dataSpace.content);
                    if (parsedContent["groups"]) {
                        let findIndex = parsedContent["groups"].findIndex(g => g.groupId == groupId)
                        if (findIndex > -1) {
                            this.dataSpaceList.push(dataSpace);
                        } 
                    }
                }
            }
        },
        showAlert() {
            this.hidden = "showAlertBlock";
        },
        async changeUser() {
            await authApi.logout();
            this.$router.push('/');
        }
    },
    data() {
        return {
            loginInfo: {
                isAuthenticated: false,
                usergroup: null,
                userrole: ""
            },
            hidden: "hidden",
            userrole: "",
            dataSpaceList: [],
            filterInput: "",
            params: "",
            name: ""
        }
    }
};
</script>